var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons-container",class:{
    'display-on-empty-state': _vm.displayOnEmptyState,
    'has-small-gap': _vm.hasSmallGap,
    'fill-width': _vm.fillWidth,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }